export default function (value: number | string, maximumFractionDigits = 2) {
  value = Number(value)

  if (Number.isNaN(value)) {
    return undefined
  }

  const { $i18n } = useNuxtApp()

  const i18nLocale = $i18n.locales.value.find(
    locale => locale.code === $i18n.locale.value,
  )

  return Intl.NumberFormat(i18nLocale?.language || 'fr-FR', {
    maximumFractionDigits,
    style: 'decimal',
  })
    .format(value)
    .replaceAll('\u00A0', ' ')
    .replaceAll('\u202F', ' ')
}
